<template>
    <div
        v-if="localVisible"
        :id="id"
        :class="[
            'dt-message-box',
            {
                error: type === 'error',
                success: type === 'success',
            },
        ]"
        :style="{ margin: margin }"
    >
        <img
            v-if="type === 'error' && showIcon"
            :src="errorIcon"
            width="16"
            height="16"
            alt="Error Icon"
        />
        <img
            v-if="type === 'success' && showIcon"
            :src="successIcon"
            width="16"
            height="16"
            alt="Success Icon"
        />
        <div class="title">{{ title }}</div>
        <div class="messsage">{{ localMessage }}</div>
    </div>
</template>

<script>
import EventBus from "../event-bus";
export default {
    name: "MessageBox",
    props: {
        id: {
            type: String,
            default: "",
        },
        visible: {
            type: Boolean,
            default: false,
        },
        type: {
            type: String,
            default: "error",
            validator: function (value) {
                return ["error", "success"].includes(value);
            },
        },
        showIcon: {
            type: Boolean,
            default: true,
        },
        icon: {
            type: String,
            default: "",
        },
        title: {
            type: String,
            required: true,
        },
        message: {
            type: String,
            required: true,
        },
        margin: {
            type: String,
            default: "0",
        },
        animation: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            localVisible: this.visible,
            localMessage: this.message,
        };
    },
    watch: {
        // Parents can change the text before showing the box (e.g. the upload's rejection reason).
        message(value) {
            this.localMessage = value;
        },
    },
    computed: {
        errorIcon() {
            return this.icon !== ""
                ? this.icon
                : require("@/assets/customizer_icon_mb_error.svg");
        },
        successIcon() {
            return this.icon !== ""
                ? this.icon
                : require("@/assets/customizer_icon_mb_success.svg");
        },
    },
    methods: {
        changeLocalMessage(id, message) {
            if (id !== this.id) {
                return;
            }

            this.localMessage = message;
        },
        hideMessageBox(id) {
            if (id !== this.id) {
                return;
            }

            this.localVisible = false;
        },
        showMessageBox(id) {
            if (id !== this.id) {
                return;
            }
            this.localVisible = true;

            setTimeout(() => {
                const element = document.getElementById(this.id);
                if (element && this.animation) {
                    const offset =
                        element.getBoundingClientRect().top +
                        window.scrollY -
                        32;
                    window.scrollTo({
                        top: offset,
                        behavior: "smooth",
                    });

                    element.style.transform = "scale(1.05)";
                    setTimeout(() => {
                        element.style.transform = "scale(1)";
                    }, 300);
                }
            }, 100);
        },
    },
    mounted() {
        EventBus.on("changeMessageBoxText", this.changeLocalMessage);
        EventBus.on("hideMessageBox", this.hideMessageBox);
        EventBus.on("showMessageBox", this.showMessageBox);
    },
    beforeUnmount() {
        EventBus.off("changeMessageBoxText", this.changeLocalMessage);
        EventBus.off("hideMessageBox", this.hideMessageBox);
        EventBus.off("showMessageBox", this.showMessageBox);
    },
};
</script>

<style lang="scss" scoped>
@use "@/assets/customizer.vars.scss" as *;
.dt-message-box {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    column-gap: 12px;
    row-gap: 8px;
    width: 100%;
    padding: 16px;
    border-radius: 16px;
    border: 1px solid transparent;
    transition: transform 0.3s;

    @media (max-width: $breakpoint-tablet) {
        flex-wrap: wrap;
    }

    &.success {
        border-color: #11bd90;
        background-color: #e7f7f8;
        color: #11bd90;
    }

    &.error {
        border-color: rgba(255, 52, 29, 0.6);
        background-color: rgba(255, 52, 29, 0.15);
        color: #ff341d;
    }

    > img {
        min-width: 16px;
        width: 16px;
        height: 16px;
    }

    .title {
        margin: 0;
        white-space: nowrap;
        font-weight: 700;
    }
}
</style>
